export type EntityReferenceType = "client" | "contract" | "equipment" | "job" | "orderedPart";

// OrderedPart lives under its parent Part in the route (there's no flat
// /ordered-parts/:id route), so its "id" is a composite "partId/orderedPartId"
// string. Build/parse it with the helpers below rather than passing a bare id.
export const buildOrderedPartReferenceId = (
  partId: string | number,
  orderedPartId: string | number
): string => `${partId}/${orderedPartId}`;

export const buildEntityDetailRoute = (
  type: EntityReferenceType,
  id: string | number
): string => {
  switch (type) {
    case "client":
      return `/clients/${id}`;
    case "contract":
      return `/contracts/${id}`;
    case "equipment":
      return `/equipment-section/equipments/${id}`;
    case "job":
      return `/service/jobs/${id}`;
    case "orderedPart": {
      const [partId, orderedPartId] = String(id).split("/");
      return `/service/stock-status/${partId}/ordered-parts/${orderedPartId}`;
    }
    default:
      return "/";
  }
};
